import { has } from 'lodash';
import * as ActionTypes from '../components/actions/types';


const initialState = {
  isPolicyAccepted: false,
  isLoggedIn: false,
  isProfileCompleted: false,
  lastViewedEssentialPage: '',
  userCurrentTeamId: -1,
  userSelectedTeamId: -1,
  intercomEnabled: true,
  inTeamChat: false,
  userInEvents: [],
  messages: [],
  githubRepos: [],
  eventApplied: [],
  eventSubmissions: [],
  groupPermissions: [],
  isPaidUser: false,
  numberOfEventsCreated: -1
};

function userReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.ACCEPT_POLICY:
      return {
        ...state,
        isPolicyAccepted: true
      };
    case ActionTypes.USER_SIGNUP_ROLE:
      return {
        ...state,
        signupRole: action.payload
      };
    case ActionTypes.USER_THIRD_PARTY_INFO:
      return {
        ...state,
        githubUsername: action.payload.githubUsername,
        thirdPartyIdentification: action.payload.id,
        thirdPartyEmail: action.payload.email,
        thirdPartyFrom: action.payload.from,
        thirdPartyFirstName: action.payload.firstName,
        thirdPartyLastName: action.payload.lastName,
        thirdPartyUsername: action.payload.username,
        ifThirdPartyEmailExist: action.payload.ifThirdPartyEmailExist,
        ifHHAccWithSameEmailExist: action.payload.ifHHAccWithSameEmailExist,
        hidePasswdFromSignup: action.payload.hidePasswdFromSignup,
        googleTokenId: action.payload.googleTokenId
      };
    case ActionTypes.USER_CANCEL_SOCIAL_LOGIN:
      if (has(state, 'githubUsername')) {
        delete state.githubUsername;
      }
      if (has(state, 'googleTokenId')) {
        delete state.googleTokenId;
      }
      if (has(state, 'githubState')) {
        delete state.githubState;
      } else if (has(state, 'linkedinState')) {
        delete state.linkedinState;
      }
      try {
        delete state.thirdPartyIdentification;
        delete state.thirdPartyEmail;
        delete state.thirdPartyFrom;
        delete state.thirdPartyFirstName;
        delete state.thirdPartyLastName;
        delete state.thirdPartyUsername;
        delete state.ifThirdPartyEmailExist;
        delete state.ifHHAccWithSameEmailExist;
        delete state.hidePasswdFromSignup;
      } catch (err) {
        // do nothing
      }
      return {
        ...state
      };
    case ActionTypes.USER_THIRD_PARTY_INFO_CLEAN:
      if (has(state, 'googleTokenId')) {
        delete state.googleTokenId;
      }
      if (has(state, 'githubState')) {
        delete state.githubState;
      } else if (has(state, 'linkedinState')) {
        delete state.linkedinState;
      }
      return {
        ...state,
        thirdPartyIdentification: null,
        thirdPartyEmail: null,
        thirdPartyFrom: null,
        thirdPartyFirstName: null,
        thirdPartyLastName: null,
        thirdPartyUsername: null,
        ifThirdPartyEmailExist: null,
        ifHHAccWithSameEmailExist: null
      };
    case ActionTypes.USER_GITHUB_STATE:
      return {
        ...state,
        githubState: action.payload
      };
    case ActionTypes.USER_GITHUB_ID:
      return {
        ...state,
        profile: {
          ...state.profile,
          socialMedia: {
            ...state.profile.socialMedia,
            github: action.payload
          }
        }
      };
    case ActionTypes.USER_LINKEDIN_STATE:
      return {
        ...state,
        linkedinState: action.payload
      };
    case ActionTypes.USER_SIGNUP:
      return {
        ...state,
        token: action.payload.token,
        isLoggedIn: true,
        profile: {
          basicInfo: {
            signUpRole: action.payload.intercom.signup_role
          }
        }
      };
    case ActionTypes.USER_LOGIN:
      return {
        ...state,
        groupPermissions: action.payload.groupPermissions,
        numberOfEventsCreated: action.payload.numberOfEventsCreated,
        isPaidUser: action.payload.isPaidUser,
        token: action.payload.token,
        isLoggedIn: true,
        profile: {
          basicInfo: {
            signUpRole: action.payload.intercom.signup_role
          }
        }
      };
    case ActionTypes.HACKHUB_ACCOUNT_LOGIN:
      return {
        ...state,
        groupPermissions: action.payload.groupPermissions,
        numberOfEventsCreated: action.payload.numberOfEventsCreated,
        isPaidUser: action.payload.isPaidUser,
        token: action.payload.token,
        isLoggedIn: true,
        // add sign up role
        profile: {
          basicInfo: {
            signUpRole: action.payload.intercom.signup_role
          }
        }
      };
    case ActionTypes.USER_UPDATE_PERMISSION:
      return {
        ...state,
        groupPermissions: action.payload.groupPermissions,
        isPaidUser: action.payload.isPaidUser
      };

    case ActionTypes.USER_UPDATE_TOKEN:
      return {
        ...state,
        token: action.payload
      };
    case ActionTypes.ENABLE_INTERCOM:
      return {
        ...state,
        intercomEnabled: true
      };
    case ActionTypes.DISABLE_INTERCOM:
      return {
        ...state,
        intercomEnabled: false
      };
    case ActionTypes.USER_LOGOUT:
      return {
        ...initialState,
        isPolicyAccepted: state.isPolicyAccepted
      };
    case ActionTypes.USER_FETCH_INFO:
      return {
        ...state,
        // profile: action.payload
        // add sign up role under basic info
        profile: {
          ...state.profile,
          basicInfo: {
            ...action.payload.basicInfo,
            signUpRole: state.profile.basicInfo.signUpRole || state.profile.basicInfo.signupRole
          },
          eventSubmissionList: [...action.payload.eventSubmissionList],
          socialMedia: {
            ...action.payload.socialMedia
          }
        }
      };
    case ActionTypes.FETCH_USER_COMPANY:
      return {
        ...state,
        companies: action.payload
      };
    case ActionTypes.UPDATE_LAST_VIEWED_ESSENTIAL_PAGE:
      return {
        ...state,
        lastViewedEssentialPage: action.payload
      };
    case ActionTypes.RESET_LAST_VIEWED_ESSENTIAL_PAGE:
      return {
        ...state,
        lastViewedEssentialPage: ''
      };
    case ActionTypes.SET_USER_CURRENT_TEAM:
      return {
        ...state,
        userCurrentTeamId: action.payload
      };
    case ActionTypes.SET_USER_SELECTED_TEAM:
      return {
        ...state,
        userSelectedTeamId: action.payload
      };
    case ActionTypes.SET_USER_PHONE_VERIFIED:
      return {
        ...state,
        profile: {
          ...state.profile,
          basicInfo: {
            ...state.profile.basicInfo,
            isPhoneVerified: action.payload
          }
        }
      };
    case ActionTypes.USER_UPDATE_AVATAR:
      return {
        ...state,
        profile: {
          ...state.profile,
          basicInfo: {
            ...state.profile.basicInfo,
            avatarUrl: action.payload
          }
        }
      };
    case ActionTypes.USER_UPDATE_SOCIAL_MEDIA:
      return {
        ...state,
        profile: {
          ...state.profile,
          socialMedia: action.payload
        }
      };
    case ActionTypes.IN_TEAM:
      return {
        ...state,
        inTeamChat: action.payload
      };
    case ActionTypes.FETCH_EVENTS: {
      return {
        ...state,
        userInEvents: action.userInEvents
      };
    }
    case ActionTypes.SET_USER_RESUME_ANALYSIS: {
      return {
        ...state,
        profile: {
          ...state.profile,
          basicInfo: {
            ...state.profile.basicInfo,
            resumeAnalysis: action.payload
          }
        }
      };
    }
    case ActionTypes.SET_USER_EMAIL_VERIFIED: {
      if (has(state, 'profile.basicInfo')) {
        return {
          ...state,
          profile: {
            ...state.profile,
            basicInfo: {
              ...state.profile.basicInfo,
              isEmailVerified: true
            }
          }
        };
      }
      return state;
    }
    case ActionTypes.USER_FETCH_GITHUB_REPOS: {
      return {
        ...state,
        githubRepos: action.payload
      };
    }
    case ActionTypes.USER_RESET_GITHUB_REPOS: {
      return {
        ...state,
        githubRepos: []
      };
    }
    case ActionTypes.DISABLE_PROFILE_TUTORIAL_STEPS: {
      return has(state, 'profile.basicInfo.newUser')
        ? {
          ...state,
          profile: {
            ...state.profile,
            basicInfo: {
              ...state.profile.basicInfo,
              newUser: false
            }
          }
        }
        : state;
    }
    case ActionTypes.USER_EVENTAPPLIED:
      return {
        ...state,
        eventApplied: [...state.eventApplied, action.payload]
      };
    case ActionTypes.EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          basicInfo: {
            ...state.profile.basicInfo,
            isEmailVerified: true
          }
        }
      };
    case ActionTypes.ACCOUNT_REGISTER:
      return {
        ...state,
        profile: {
          ...state.profile,
          basicInfo: {
            ...action.payload.basicInfo
          }
        },
        token: action.payload.token,
        isLoggedIn: true
      };
    default: {
      return state;
    }
  }
}

export default userReducer;



// WEBPACK FOOTER //
// ./src/reducers/user.js